// Petra Fina: reduce product decision friction without adding PDP clutter.
(function () {
  if (window.__petraPdpDecisionFlow) return;
  window.__petraPdpDecisionFlow = true;

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function isColorOption(value) {
    var name = normalize(value && value.name ? value.name : value);
    return name === 'cor' || name === 'color' || name === 'cores';
  }

  function fileKey(value) {
    var path = String(value || '').split('?')[0].split('#')[0];
    var file = path.slice(path.lastIndexOf('/') + 1).toLowerCase();
    return file
      .replace(/_\{width\}x(?:\.progressive)?(?=\.)/g, '')
      .replace(/_\d+x(?:@\d+x)?(?:\.progressive)?(?=\.)/g, '')
      .replace(/\.progressive(?=\.)/g, '');
  }

  function getProductRoot() {
    return document.querySelector('single-product[data-js-product][data-product-handle]');
  }

  function getSelectedColor(root) {
    var sections = root.querySelectorAll('.product-options__section[data-property]');
    for (var index = 0; index < sections.length; index += 1) {
      if (!isColorOption(sections[index].getAttribute('data-property'))) continue;
      var active = sections[index].querySelector('[data-js-option-value].active');
      return active && active.getAttribute('data-value');
    }
    return null;
  }

  function loadProduct(root) {
    var handle = root && root.getAttribute('data-product-handle');
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function colorIndex(product) {
    var index = -1;
    (product.options || []).forEach(function (option, optionIndex) {
      if (isColorOption(option)) index = optionIndex;
    });
    return index;
  }

  function mediaGroups(product, gallery) {
    var colorAt = colorIndex(product);
    if (colorAt < 0) return null;
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-js-product-gallery-main-item][data-item-index]'));
    if (!items.length) return null;

    var itemByFile = {};
    items.forEach(function (item) {
      var image = item.querySelector('img[data-master], img[data-src], img[src]');
      var key = fileKey(image && (image.getAttribute('data-master') || image.getAttribute('data-src') || image.getAttribute('src')));
      if (key) itemByFile[key] = Number(item.getAttribute('data-item-index'));
    });

    var starts = [];
    (product.variants || []).forEach(function (variant) {
      var color = variant.options && variant.options[colorAt];
      var featured = variant.featured_image && variant.featured_image.src;
      var index = itemByFile[fileKey(featured)];
      if (!color || !Number.isFinite(index)) return;
      if (!starts.some(function (entry) { return entry.color === color; })) starts.push({ color: color, index: index });
    });
    starts.sort(function (a, b) { return a.index - b.index; });
    if (starts.length < 2) return null;

    var allIndexes = items.map(function (item) { return Number(item.getAttribute('data-item-index')); }).sort(function (a, b) { return a - b; });
    var groups = {};
    starts.forEach(function (entry, index) {
      var next = starts[index + 1] ? starts[index + 1].index : Infinity;
      groups[normalize(entry.color)] = allIndexes.filter(function (itemIndex) {
        return itemIndex >= entry.index && itemIndex < next;
      });
    });
    return groups;
  }

  function filterSlider(slider, allowed) {
    var jq = window.jQuery;
    if (!slider || !jq || !jq.fn || !jq.fn.slick) return false;
    var $slider = jq(slider);
    if (!$slider.hasClass('slick-initialized')) return false;
    try {
      $slider.slick('slickUnfilter');
      $slider.slick('slickFilter', function () {
        return allowed.indexOf(Number(this.getAttribute('data-item-index'))) !== -1;
      });
      $slider.slick('slickGoTo', 0, true);
      return true;
    } catch (error) {
      return false;
    }
  }

  function filterGallerySliders(allowed) {
    return Array.prototype.slice.call(document.querySelectorAll('[data-js-product-gallery-main-slider], .product-gallery__fullscreen .slick-initialized'))
      .filter(function (slider) { return slider.querySelector('[data-item-index]'); })
      .map(function (slider) { return filterSlider(slider, allowed); })
      .some(Boolean);
  }

  function markGalleryMedia(allowed) {
    Array.prototype.slice.call(document.querySelectorAll('[data-js-product-gallery-main-item][data-item-index]')).forEach(function (item) {
      var isAllowed = allowed.indexOf(Number(item.getAttribute('data-item-index'))) !== -1;
      item.setAttribute('data-petra-color-media', isAllowed ? 'true' : 'false');
    });
  }

  function filterGallery(root, product, groups) {
    var gallery = document.querySelector('[data-js-product-gallery]');
    var color = getSelectedColor(root);
    if (!gallery || !color) return;
    var allowed = groups[normalize(color)];
    if (!allowed || !allowed.length) return;
    markGalleryMedia(allowed);
    if (filterGallerySliders(allowed)) {
      gallery.classList.add('petra-gallery-color-filtered');
    }
  }

  function initGalleryByColor() {
    var root = getProductRoot();
    var gallery = document.querySelector('[data-js-product-gallery]');
    if (!root || !gallery || root.dataset.petraGalleryFilterReady) return;
    root.dataset.petraGalleryFilterReady = 'pending';
    loadProduct(root).then(function (product) {
      var groups = product && mediaGroups(product, gallery);
      if (!groups) { delete root.dataset.petraGalleryFilterReady; return; }
      root.dataset.petraGalleryFilterReady = 'true';
      var refresh = function () {
        filterGallery(root, product, groups);
      };
      refresh();
      root.addEventListener('click', function (event) {
        if (!event.target.closest('[data-js-option-value]')) return;
        window.setTimeout(refresh, 180);
        window.setTimeout(refresh, 650);
      });
      document.addEventListener('click', function (event) {
        if (!event.target.closest('[data-js-product-gallery-main-item]')) return;
        window.setTimeout(refresh, 120);
        window.setTimeout(refresh, 700);
      }, true);
      window.setTimeout(refresh, 1000);
    });
  }

  function injectReviewStyle() {
    if (document.getElementById('petra-review-summary-style')) return;
    var style = document.createElement('style');
    style.id = 'petra-review-summary-style';
    style.textContent = [
      '#revieList .summary h2 { font-size: 26px !important; letter-spacing: 0 !important; }',
      '#revieList .summary .table { display: flex; align-items: center; gap: 8px; margin: 0; }',
      '#revieList .summary .table-start { display: inline-flex; align-items: center; min-height: 30px; padding: 0 8px; background: #f3f0ee; color: #312b2e; font-size: 14px; font-weight: 600; }',
      '#revieList .petra-review-stars { display: inline-flex; align-items: center; color: #1e1a1c; font-size: 18px; letter-spacing: 1px; line-height: 1; }',
      '#revieList .petra-review-more { display: inline-flex; align-items: center; justify-content: center; min-height: 42px; margin: 8px 0 24px; padding: 0 18px; border: 1px solid #1f1b1d; background: #fff; color: #1f1b1d; font-size: 12px; font-weight: 600; letter-spacing: .04em; text-transform: uppercase; cursor: pointer; }',
      '[data-js-product-gallery].petra-gallery-color-filtered [data-js-product-gallery-thumbnail-slider] { display: none !important; }',
      '.product-gallery__fullscreen [data-petra-color-media="false"] { display: none !important; }',
      'body.template-product:not(.petra-purchase-end-ready) .product-fixed-sizebar { display: none !important; }',
      '@media (max-width: 767px) { #revieList .summary { align-items: flex-start !important; gap: 12px; } #revieList .summary h2 { font-size: 20px !important; } #revieList .summary .table-start { font-size: 12px; } }',
    ].join('\n');
    document.head.appendChild(style);
  }

  function improveReviews() {
    var root = document.getElementById('revieList');
    if (!root) return;
    var title = root.querySelector('.summary h2');
    if (title) title.textContent = 'Avalia' + String.fromCharCode(231) + String.fromCharCode(245) + 'es desse produto';
    var score = root.querySelector('.summary .table-start');
    var stars = root.querySelector('.summary [data-starlist]');
    if (score && !score.dataset.petraScoreFormatted) {
      score.dataset.petraScoreFormatted = 'true';
      score.textContent = String(score.textContent || '').trim().replace('.', ',') + ' / 5';
    }
    if (stars && !stars.parentNode.querySelector('.petra-review-stars')) {
      var label = document.createElement('span');
      label.className = 'petra-review-stars';
      label.setAttribute('aria-label', 'AvaliaÃ§Ã£o em estrelas');
      label.textContent = '★★★★★';
      stars.parentNode.insertBefore(label, stars);
      stars.style.display = 'none';
    }

    var rows = Array.prototype.slice.call(root.querySelectorAll('.detail-star'));
    if (rows.length <= 3) return;
    var expanded = root.dataset.petraReviewsExpanded === 'true';
    rows.forEach(function (row, index) { row.hidden = !expanded && index > 2; });
    var button = root.querySelector('.petra-review-more');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'petra-review-more';
      button.addEventListener('click', function () {
        root.dataset.petraReviewsExpanded = root.dataset.petraReviewsExpanded === 'true' ? 'false' : 'true';
        improveReviews();
      });
      var pagination = root.querySelector('.paginationRevie');
      root.insertBefore(button, pagination || null);
    }
    button.textContent = expanded ? 'Mostrar menos' : 'Ver mais avalia' + String.fromCharCode(231) + String.fromCharCode(245) + 'es';
  }

  function watchReviews() {
    var root = document.getElementById('revieList');
    if (!root || root.dataset.petraReviewsWatching) return;
    root.dataset.petraReviewsWatching = 'true';
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; improveReviews(); });
    }).observe(root, { childList: true, subtree: true });
  }

  function updatePurchaseBar() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    var documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    var nearEnd = window.scrollY + window.innerHeight >= documentHeight - 420;
    document.body.classList.toggle('petra-purchase-end-ready', nearEnd);
    Array.prototype.slice.call(document.querySelectorAll('body *')).forEach(function (node) {
      if (!node.querySelector || !node.querySelector('[data-js-product-button-add-to-cart], .product-page-info__button-add-to-cart')) return;
      var style = window.getComputedStyle(node);
      if (style.position !== 'fixed') return;
      node.style.setProperty('display', nearEnd ? '' : 'none', 'important');
      node.style.setProperty('pointer-events', nearEnd ? '' : 'none', 'important');
    });
  }

  function init() {
    injectReviewStyle();
    initGalleryByColor();
    improveReviews();
    watchReviews();
    updatePurchaseBar();
    window.addEventListener('scroll', updatePurchaseBar, { passive: true });
    new MutationObserver(updatePurchaseBar).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.setTimeout(init, 1000);
  window.setTimeout(init, 3000);
  window.setTimeout(init, 6000);
})();
